var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 7.33332V5.49999C12.8333 5.01376 12.6402 4.54744 12.2964 4.20363C11.9525 3.85981 11.4862 3.66666 11 3.66666H4.58333C4.0971 3.66666 3.63079 3.85981 3.28697 4.20363C2.94315 4.54744 2.75 5.01376 2.75 5.49999V16.5C2.75 16.9862 2.94315 17.4525 3.28697 17.7964C3.63079 18.1402 4.0971 18.3333 4.58333 18.3333H11C11.4862 18.3333 11.9525 18.1402 12.2964 17.7964C12.6402 17.4525 12.8333 16.9862 12.8333 16.5V14.6667",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 11H19.2498M19.2498 11L16.4998 8.25M19.2498 11L16.4998 13.75",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0feed64da4688eca0341b40654707a43.svg";
export { ForwardRef as ReactComponent };